<div>
  <mat-form-field *ngIf="searchLocation" appearance="outline" class="search-box w-50">
    <mat-label>Buscar Ubicación</mat-label>
    <input matInput #searchBox id="pac-input" type="text" placeholder="Buscar Ubicación" />
  </mat-form-field>
  <google-map #googleMap width="100%" height="600px" [center]="center" [zoom]="zoom" [options]="mapOptions"
    (mapClick)="addMarker($event)">
    <div *ngIf="!routerFinished">
      <map-marker *ngFor="let marker of markers; let i = index" [position]="marker.position" [options]="marker.option"
        [label]="{
                color: 'black',
                fontSize: '16px',
                fontWeight: 'bold',
                text: (marker.order === marker.id ? marker.order : marker.order + ' - ' + marker.id)
              }" (mapDragend)="markerDragEnd($event, i)" (mapClick)="openInfoWindow($event, i)"
        [draggable]="marker.option.draggable">

      </map-marker>

      <!-- <map-circle *ngFor="let circle of circles"
                  [center]="circle.center"
                  [radius]="circle.radius"
                  [options]="circle.options">
      </map-circle> -->

    </div>

    <map-info-window #infoWindow>
      <div style="display: flex; flex-direction: column; align-items: center;">

        <mat-form-field>
          <input autocomplete="off" type="text" matInput maxlength="45" placeholder="Nombre del marcador"
            [(ngModel)]="selectedMarkerName" />
        </mat-form-field>

        <combos class="col-12 " style="width: 100%;" [dataCombos]="markers" [configuration]="combosConfigMarker"
          [reloadCombo]="reloadComboMarker" [filter]="true" (changeOption)="changeValueMarker($event)"
          [disabled]="true">
        </combos>



        <div style="display: flex; justify-content: space-around; width: 100%; margin-top: 10px;">
          <button #buttonRemove type="button" mat-icon-button color="warn" (click)="removeMarker(selectedMarkerIndex)"
            [disabled]="markers[selectedMarkerIndex]?.order === 'Punto Origen' || markers[selectedMarkerIndex]?.order === 'Ciudad Destino'">
            <mat-icon>delete</mat-icon>
          </button>
          <button type="button" mat-icon-button color="primary" (click)="saveMarkerLabel()">
            <mat-icon>save</mat-icon>
          </button>
        </div>

      </div>
    </map-info-window>

    <map-directions-renderer *ngIf="routerFinished && directionsResults" [directions]="directionsResults"></map-directions-renderer>

  </google-map>

</div>
